// Khoảng ngày (theo giờ máy người dùng) cho bộ lọc lịch sử. Giá trị input type="date": "YYYY-MM-DD".
export const dayStart = (d: string) => (d ? new Date(`${d}T00:00:00`) : null);
export const dayEnd = (d: string) => (d ? new Date(`${d}T23:59:59.999`) : null);

// Phiên gửi xe có thời gian gửi giao với khoảng [from, to] (phiên đang gửi coi như kéo dài tới hiện tại).
export function overlapsRange(entry: string, exit: string | null | undefined, from: string, to: string) {
    const start = new Date(entry).getTime();
    const end = exit ? new Date(exit).getTime() : Date.now();
    const f = dayStart(from);
    const t = dayEnd(to);
    return (!f || end >= f.getTime()) && (!t || start <= t.getTime());
}

export const toDateInput = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const todayInput = () => toDateInput(new Date());

export const daysAgoInput = (days: number) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return toDateInput(d);
};
